var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.chip_color,"text-color":_vm.text_color,"small":""}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',{attrs:{"color":_vm.icon_color,"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_vm._v(" "+_vm._s(_vm.percent_text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }